import { prop, inject, ComponentEventBus } from "fw";
import { Form } from "fw-model";

@inject
export class TextareaFormField {
    @prop(null) public form!: Form;
    @prop(null) public field: string;
    @prop(null) public label!: string;
    @prop(false) public readonly: boolean;
    @prop(false) public disabled: boolean;
    @prop(null) public placeholder: string;
    @prop(true) enableAutosize: boolean;
    @prop("1") rows: string;

    private name = "";

    constructor(private ceb: ComponentEventBus) {}

    public attached(): void {
        this.formChanged();
    }

    private formChanged(): void {
        this.name = this.form && this.form.getFieldName ? this.form.getFieldName(this.field) : this.field;
    }

    private onChange(): void {
        this.ceb.dispatch("change");
    }
    private onKeyUp(): void {
        this.ceb.dispatch("keyup");
    }
}
